import { useCallback, useState } from "react";
import { useHeaderHidden } from "../../../hooks/use-header-hidden";
import { useBodyScrollLock } from "../../../hooks";
import { type PDPGalleryProp } from "../PDP_SingleImageCarousel/PDPStickyGallery";
import { nonEmpty } from "../../../utils/fp/small-fp-utils";

export function usePdpGalleryWithLightbox(galleryConfig: PDPGalleryProp): PdpGalleryWithLightboxProps {
  const [modalUrl, setModalUrl] = useState<string | undefined>(undefined);

  const openModal = (url: string) => {
    // defer it so that UI has a slice of time to adjust (hide header, mainly)
    window.setTimeout(() => setModalUrl(url), 0);
  };

  const closeModal = useCallback(() => {
    setModalUrl(undefined);
  }, []);

  const els = galleryConfig
    ? [galleryConfig.primaryImage, ...galleryConfig.scrollingGalleryElements].filter(nonEmpty)
    : [];
  const modalIdx = modalUrl
    ? els.findIndex(e => {
        if (e.__typename === "Image") {
          return e.url === modalUrl;
        } else {
          return e.video.url == modalUrl;
        }
      })
    : -1;

  const isModalActive = modalIdx >= 0;

  useHeaderHidden(isModalActive);
  useBodyScrollLock(isModalActive);

  if (!galleryConfig) {
    return undefined;
  }

  return {
    isModalActive,
    modalIdx,
    openModal,
    closeModal,
    galleryConfig,
  };
}

export type PdpGalleryWithLightboxProps =
  | {
      isModalActive: boolean;
      modalIdx: number;
      openModal: (url: string) => void;
      closeModal: () => void;
      galleryConfig: NonNullable<PDPGalleryProp>;
    }
  | undefined;
